"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcIsExpanded = void 0;
function calcIsExpanded(view, node) {
    var _a, _b, _c;
    const noGroupBys = ((_a = view.groupBys) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const isItemCollection = !!(node === null || node === void 0 ? void 0 : node.itemCollection);
    const isLoadingItems = !isItemCollection
        ? false
        : !!((_b = node === null || node === void 0 ? void 0 : node.itemCollection) === null || _b === void 0 ? void 0 : _b.loading) || !((_c = node === null || node === void 0 ? void 0 : node.itemCollection) === null || _c === void 0 ? void 0 : _c.lastLoaded);
    return (!isLoadingItems &&
        (!!node.expanded || (!!node.highlighted && !(isItemCollection && noGroupBys === 2))));
}
exports.calcIsExpanded = calcIsExpanded;
exports.default = calcIsExpanded;
